import useEditPaymentMethod, {
  EditPaymentMethodProps,
} from 'modules/payment-methods/hooks/use-edit-payment-method';
import {
  PaymentTypeEnum,
  translatedPaymentMethodProps,
} from 'modules/payment-methods/types';
import paymentMethodsKeys from 'modules/payment-methods/util/payment-methods-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditPaymentMethod: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSwitch, getSelect} = useFormInputs();

  return (
    <Edition<EditPaymentMethodProps>
      titleBar={{title: 'Editar forma de pagamento'}}
      inputs={[
        getInput({name: 'name'}),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'type',
          data: [
            {label: 'Online', value: PaymentTypeEnum.ONLINE},
            {label: 'Na entrega', value: PaymentTypeEnum.IN_PERSON},
          ],
        }),
      ]}
      detailsUrl={`/payment-methods/${id}`}
      onSubmit={() => useEditPaymentMethod(id!)}
      translationKey={translatedPaymentMethodProps}
      queryKey={paymentMethodsKeys.details(id!)}
    />
  );
};

export default EditPaymentMethod;
